export const arrayToMap = (array: (string | number)[]) => {
    return (array ?? []).reduce((prev, current) => {
        prev[current] = 1;
        return prev;
    }, {});
};
